"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var useAutosizeTextArea_1 = __importDefault(require("../../../../../app/components/hooks/useAutosizeTextArea"));
var CommentContextInterface_1 = require("../CommentContextInterface");
var ResponceContent = function (props) {
    var _a;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_1.useState)({ name: "", comment: "" }), commentValue = _c[0], setCommentValue = _c[1];
    var _d = (0, react_1.useState)(), responceError = _d[0], setresponceError = _d[1];
    var _e = (0, react_1.useState)({ name: false }), errors = _e[0], setErrors = _e[1];
    var textAreaRef = (0, react_1.useRef)(null);
    var inputTextRef = (0, react_1.useRef)(null);
    var user = (0, CommentContextInterface_1.useCommentContext)().user;
    (0, useAutosizeTextArea_1.default)(textAreaRef.current, commentValue.comment);
    function handleClickEvent() {
        if (!commentValue.name.trim().length && !user) {
            setErrors(function (prev) { return (__assign(__assign({}, prev), { name: true })); });
            return;
        }
        if (!props.commentId) {
            return;
        }
        axios_1.default.post("/app/comment/create", {
            user_name: commentValue.name.trim(),
            comment: commentValue.comment.trim(),
            parent_comment_id: props.commentId,
            current_link: window.location.href
        }).then(function (response) {
            if (response.status == 200) {
                handleClearComment();
                setresponceError(undefined);
                if (props.onCreate) {
                    props.onCreate(response.data);
                }
            }
        }).catch(function (error) {
            if (error.response) {
                if (error.response.status = 403) {
                    setresponceError({
                        status: error.response.status,
                        current_timestamp_create: error.response.data.current_timestamp_create,
                        last_timestamp_create: error.response.data.last_timestamp_create,
                        time: error.response.data.time
                    });
                }
            }
        });
    }
    (0, react_1.useEffect)(function () {
        if (commentValue) {
            if (commentValue.name.trim().length) {
                setErrors(function (prev) { return (__assign(__assign({}, prev), { name: false })); });
            }
        }
    }, [commentValue]);
    function handleClearComment() {
        setCommentValue({ name: "", comment: "" });
        if (inputTextRef.current) {
            inputTextRef.current.value = '';
        }
        if (textAreaRef.current) {
            textAreaRef.current.value = '';
        }
    }
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("div", { className: "__responce-content" },
            react_1.default.createElement("div", { className: "__wrap-auth" }, !user &&
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "__caption-name" }, t("comments.header.auth.name")),
                    react_1.default.createElement("div", { className: "__wrap-input-name" },
                        react_1.default.createElement("input", { ref: inputTextRef, onChange: function (e) { return setCommentValue(function (prev) { return (__assign(__assign({}, prev), { name: e.target.value })); }); }, className: (0, classnames_1.default)(errors.name ? "__input-name-error" : "__input-name"), placeholder: t("comments.header.auth.input.placeholder") })))),
            react_1.default.createElement("div", { className: "__wrap-textarea" },
                react_1.default.createElement("textarea", { ref: textAreaRef, rows: 1, onChange: function (e) { return setCommentValue(function (prev) { return (__assign(__assign({}, prev), { comment: e.target.value })); }); }, className: "__input-root-value", placeholder: t("comments.responce.input.placeholder") })),
            react_1.default.createElement("button", { onClick: handleClickEvent, disabled: ((_a = commentValue === null || commentValue === void 0 ? void 0 : commentValue.comment) === null || _a === void 0 ? void 0 : _a.length) == 0, type: "submit" }, t("comments.responce.submit.text")))));
};
exports.default = ResponceContent;
